<template>
  <div class="policyInformation">
    <el-row>
      <!-- 面包屑 -->
      <el-col :span="24"
        ><Breadcrumbs :arr="['碳汇管理平台', '零碳公司日']"
      /></el-col>
      <!-- 查询表单 -->
      <el-col class="search" :span="24">
        <el-form :inline="true" :model="search" class="demo-form-inline">
          <el-form-item label="交通方式">
            <el-select
              v-model="search.transport"
              clearable
              placeholder="请选择"
              size="small"
            >
              <el-option label="公共交通" :value="0"> </el-option>
              <el-option label="自驾" :value="1"> </el-option>
              <el-option label="飞机" :value="2"> </el-option>
              <el-option label="高铁" :value="3"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input
              size="small"
              v-model="search.name"
              maxlength="100"
              clearable
              placeholder="请输入"
              class="inline-input"
            ></el-input>
          </el-form-item>

           <el-form-item label="手机号码">
            <el-input
              size="small"
              v-model="search.phone"
              maxlength="100"
              clearable
              placeholder="请输入"
              class="inline-input"
            ></el-input>
          </el-form-item>
          <el-form-item id="time" label="参加日期">
            <el-date-picker
            v-model="search.startDate"
            size="small"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptionsYear"
            style="width: 200px"
            placeholder="开始日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker
            v-model="search.endDate"
            size="small"
            format="yyyy-MM-dd"
            :picker-options="pickerOptionsYear1"
            value-format="yyyy-MM-dd"
            style="width: 200px"
            placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="btn">
            <!-- class="theme-btn" -->
            <el-button size="small" type="primary" @click="selectData" round
              >查询</el-button
            >
            <el-button
              size="small"
              style="margin: 0 0 0 50px"
              @click="reset"
              round
              type="info"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 表格数据 -->
      <el-col class="main_table" :span="24">
        <div class="table_btn">
          <!-- class="theme-btn" -->
          <el-button size="small" type="primary" @click="excel" round
            >导出</el-button
          >
        </div>
        <Tables
          class="table"
          :columns="columns"
          :loading="loading"
          :tableData="tableData"
          :selectionChange="handleSelectionChange"
        >

          <template #attendClassWay="scope">
            <div>{{changeAttendClassWay(scope.row.attendClassWay) }}</div>
          </template>
          <template #transport="scope">
            <div>{{changeTransport(scope.row.transport) }}</div>
          </template>
          <template #win="scope">
            <div>{{changeWin(scope.row.win) }}</div>
          </template>
        </Tables>
        <Paginations :pageData="pageData" :sizeChange="sizeChange" :currentChange="currentChange" />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  getListByPage,
  downloadExcel
} from "@/api/api";
import Breadcrumbs from "@/components/breadcrumbs/breadcrumbs.vue";
import Tables from "@/components/tables/tables.vue";
import Paginations from "@/components/paginations/paginations.vue";
import { columns } from "./js/columns";
export default {
  name: "contributionStatistics",
  data() {
    return {
      search: {
        "attendClassWay": "",
        "endDate": "",
        "idList": [],
        "name": "",
        "phone": "",
        "startDate": "",
        "transport": ""
      },
      pickerOptionsYear: {
        disabledDate: (time) => {
          const start = Date.parse(this.search.startDate);
          const end = Date.parse(this.search.endDate);
          if (this.search.endDate) {
            return time.getTime() > Date.now() || time.getTime() > end;
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerOptionsYear1: {
          disabledDate: (time) => {
            const start = Date.parse(this.search.startDate);
            const end = Date.parse(this.search.endDate);
            if (this.search.startDate) {
              return (
                time.getTime() < start - 8.64e7
              );
            } else {
              // return time.getTime() > Date.now();
            }
          },
      },
      // 表格展示数据
      tableData: [],
      // 表格显示标题
      columns: [],
      loading: false,
      // 分页
      pageData: {
        size: 10,
        page: 1,
        total: 0,
      },
      // 用户信息
      userInfo: {},
    };
  },
  methods: {
    // 页面初始化
    init() {
      this.columns = columns;
      this.getList();
    },
     // 查询
    selectData(){
      const {name,attendClassWay,endDate,phone,startDate,transport} = this.search
      if( name|| attendClassWay||attendClassWay===0||endDate||phone||startDate||transport||transport===0){
        this.pageData.page = 1
      }
      this.getList()
    },  
    // 获取数据列表
    getList() {
      let page = {
        current: this.pageData.page,
        size: this.pageData.size,
      };
      this.loading = true
      let search = {...this.search}
      if(search.endDate)
        search.endDate = search.endDate + ' 23:59:59'
      if(search.startDate)
        search.startDate = search.startDate + ' 00:00:00'
      getListByPage(search, page).then((res) => {
        if (res.data.code == "200") {
          this.tableData = res.data.data.records;
          this.pageData.total = res.data.data.total;
        }
        this.loading = false
      });
    },
    // 点击重置
    reset() {
      this.search = {
        "attendClassWay": "",
        "endDate": "",
        "idList": [],
        "name": "",
        "phone": "",
        "startDate": "",
        "transport": ""
      };
      this.pageData.page = 1
      this.getList();
    },
    // 切换条数
    sizeChange(val){
        this.pageData.size = val
        this.getList()
    },
    // 切换页数
    currentChange(val){
        this.pageData.page = val
        this.getList()
    },
    // 修改交通方式
    changeTransport(e){
      switch(e) {
        case 0:
          return '公共交通'
        case 1:
          return '自驾'
        case 2:
          return '飞机'
        case 3:
          return '高铁'
        default: 
          return ''
      } 
    },
    // 修改上课方式
    changeAttendClassWay(e){
      switch(e) {
        case 0:
          return '线上'
        case 1:
          return '线下'
        default: 
          return ''
      } 
    },
    // 修改是否中奖
    changeWin(e){
      switch(e) {
        case 0:
          return '否'
        case 1:
          return '是'
        default: 
          return ''
      } 
    },
    // 
    handleSelectionChange(e){
      let idList = e.map(e=>e.id)
      this.search.idList = idList
      console.log(this.search);
    },
    //获取当前时间
    getNowTime() {
      var date = new Date();
      //年 getFullYear()：四位数字返回年份
      var year = date.getFullYear(); //getFullYear()代替getYear()
      //月 getMonth()：0 ~ 11
      var month = date.getMonth() + 1;
      //日 getDate()：(1 ~ 31)
      var day = date.getDate();
      var d = ''+year  + this.addZero(month)  + this.addZero(day);
      return d;
    },
    //小于10的拼接上0字符串
    addZero(s) {
        return s < 10 ? ('0' + s) : s;
    },
    // 导致excel
    excel(){
      const search = {...this.search}
      const {name,attendClassWay,endDate,phone,startDate,transport} = this.search
      if( name|| attendClassWay||attendClassWay===0||endDate||phone||startDate||transport||transport===0){
        search.idList = []
        if(search.endDate)
          search.endDate = search.endDate + ' 23:59:59'
        if(search.startDate)
          search.startDate = search.startDate + ' 00:00:00'
      }else{
        search.idList = this.tableData.map(e=>e.id)
      }
      downloadExcel(search).then(res=>{
        if(res.status === 200){
           let blob = new Blob([res.data], {type: 'application/vnd.ms-excel; charset=utf-8'})
          let url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          let date = this.getNowTime()
          link.download = '零碳公司日明细'+date+'.xls' //下载的文件名
          link.click()
          window.URL.revokeObjectURL(url);
        }
      })
    },
  },
  mounted() {
    this.init();
  },
  components: {
    Breadcrumbs,
    Tables,
    Paginations,
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.operation{
  color: #409EFF;
}
</style>